/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Pin_HighlightInputs */

const en_story_pin_highlight = /** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to Highlights`)
};

const es_story_pin_highlight = /** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar en Destacados`)
};

const fr_story_pin_highlight = /** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer dans les Temps forts`)
};

const de_story_pin_highlight = /** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Highlights speichern`)
};

const id_story_pin_highlight = /** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan ke Sorotan`)
};

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const ja_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const zh_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const ar_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const it_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const ru_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const pt_story_pin_highlight = en_story_pin_highlight;

/** @type {(inputs: Story_Pin_HighlightInputs) => LocalizedString} */
const ko_story_pin_highlight = en_story_pin_highlight;

/**
* | output |
* | --- |
* | "Save to Highlights" |
*
* @param {Story_Pin_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_pin_highlight = /** @type {((inputs?: Story_Pin_HighlightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Pin_HighlightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_pin_highlight(inputs)
	if (locale === "es") return es_story_pin_highlight(inputs)
	if (locale === "fr") return fr_story_pin_highlight(inputs)
	if (locale === "de") return de_story_pin_highlight(inputs)
	if (locale === "ja") return ja_story_pin_highlight(inputs)
	if (locale === "zh") return zh_story_pin_highlight(inputs)
	if (locale === "ar") return ar_story_pin_highlight(inputs)
	if (locale === "id") return id_story_pin_highlight(inputs)
	if (locale === "it") return it_story_pin_highlight(inputs)
	if (locale === "ru") return ru_story_pin_highlight(inputs)
	if (locale === "pt") return pt_story_pin_highlight(inputs)
	return ko_story_pin_highlight(inputs)
});